export default {
  'menu.shop-settings.price-visibility': '价格展示',
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.dashboard': '仪表盘',
  'menu.users': '用户管理',
  'menu.dashboard.system-monitor': '系统总览',
  'menu.hj.global-settings': '全局设置',
  // 新增运维与队列监控
  'menu.ops': '运维',
  'menu.shop-settings': '商城配置',
  'menu.shop-settings.static-assets': '运营图片',
  'menu.shop-settings.size-recommendations': '尺码推荐规则',
  'menu.shop-settings.size-recommendation-mapping': '尺码推荐属性映射',
  'menu.shop-sorting': '排序管理',
  'menu.hj': '商品管理',
  'menu.hj.products': '商品列表',
  'menu.hj.purchase-orders': '拿货单',
  'menu.hj.orders': '订单管理',
  'menu.hj.yarns': '纱线管理',
  'menu.hj.size-attrs': '尺码字段',
  'menu.hj.size-templates': '尺码模板',
  'menu.ai': 'AI 生图',
  'menu.ai.generation': '生图工作台',
  'menu.ai.history': '生图记录',
  'menu.ai.copy-history': '文案记录',
  'menu.settings-center': '配置中心',
  'menu.settings-center.ai-models': 'AI 大模型配置',
  'menu.settings-center.marketing-copy': '营销文案模板',
  'menu.settings-center.order-process': '订单工序配置',
  'menu.settings-center.product-config': '商品配置',
  'menu.settings-center.product-config.taxonomies': '分类词表',
  'menu.settings-center.product-config.product-attributes': '商品属性模板',
};
